export const AGREEMENT_MAIL = "agreement";
export const SETTLEMENT_MAIL = "settlement";
export const CONFIRMATION_MAIL = "confirmation";
export const SPOT_MAIL = "spot";
export const FIXED_RATE_MAIL = "fixed-rate";
export const ORDER_MAIL = "order";
export const MARGIN_CALL_MAIL = "margin-call";
export const PROLONG_MAIL = "prolong";
export const GLOBAL_MARGIN_CALL_MAIL = "global-margin-call";
